export default __webpack_public_path__ + "static/media/pilot-blue-128x128.8ea11653.png";